import type { QueryClient } from "@tanstack/react-query"
import { voiceKeys } from "./keys"
import { isVoiceMessage } from "./mappers"

function voiceMessageStructuralSharing(
	oldData: unknown,
	newData: unknown,
): unknown {
	if (!isVoiceMessage(newData)) return newData
	if (isVoiceMessage(oldData) && newData.version <= oldData.version)
		return oldData
	return newData
}

export function registerVoiceQueryDefaults(queryClient: QueryClient): void {
	queryClient.setQueryDefaults(voiceKeys.urls(), {
		staleTime: Number.POSITIVE_INFINITY,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	})
	queryClient.setQueryDefaults(voiceKeys.messages(), {
		structuralSharing: voiceMessageStructuralSharing,
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
		refetchOnMount: "always",
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		notifyOnChangeProps: ["data", "status"],
	})
}
